import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { type ComponentProps } from 'react';

import { cn } from '~/utils/cn';

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

/** Wraps Radix CollapsibleContent with a smooth height + opacity transition
 *  driven by the `--radix-collapsible-content-height` CSS variable. */
function CollapsibleContent({
  className,
  ...props
}: ComponentProps<typeof CollapsiblePrimitive.CollapsibleContent>) {
  return (
    <CollapsiblePrimitive.CollapsibleContent
      className={cn(
        'data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down overflow-hidden',
        className,
      )}
      {...props}
    />
  );
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
